<app-header [isHome]=false [isInmuebles]="true"></app-header>

<section id="filter-retailco" class="filter-retailco">

  <div class="filter-retailco-blq">

    <div class="filter-retailco-blq-inner">

      <a class="btn custom-filter" data-bs-toggle="offcanvas" data-bs-target="#offcanvasWithBackdrop">

        <img class="me-2" src="assets/img/icon-filter.svg" width="20" alt="icono filtro">Filtros</a>

      <form [formGroup]="myForm" class="formFlex">

        <mat-form-field appearance="fill">
          <mat-label>Selecciona</mat-label>
          <mat-select formControlName="isSearch4" disableOptionCentering panelClass="myPanelClass"
            placeholder="Operación">
            <mat-option *ngFor="let item of isSearch4Text" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- <select class="form-select custom-select2" aria-label="Compra o Alquiler" formControlName="isSearch4">
                        <option selected value="2">Alquilar</option>
                        <option selected value="1">Comprar</option>
                    </select> -->
        <mat-form-field appearance="fill">
          <mat-label>Tipo de inmueble</mat-label>
          <mat-select formControlName="use" disableOptionCentering panelClass="myPanelClass">
            <mat-option *ngFor="let item of uses" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Provincia</mat-label>
          <mat-select formControlName="province" disableOptionCentering panelClass="myPanelClass">
            <mat-option *ngFor="let item of provinces" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <!-- 
                    <select class="form-select custom-select2" aria-label="Tipo de inmueble"
                    formControlName="use">
                        <option selected value="">Tipo de inmueble</option>
                        <option *ngFor="let item of uses"
                                value="{{item.id}}">
                          {{item.name}}
                        </option>
                   </select>   -->
        <mat-form-field appearance="fill" (click)="clickCity()">
          <mat-label>Municipio</mat-label>
          <mat-select formControlName="city" disableOptionCentering panelClass="myPanelClass">
            <mat-option *ngFor="let item of cities" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill">
          <mat-label>Distrito</mat-label>
          <mat-select formControlName="district" disableOptionCentering panelClass="myPanelClass">
            <mat-option *ngFor="let item of districts" [value]="item.id">
              {{item.name}}
            </mat-option>
          </mat-select>

        </mat-form-field>

      </form>
    </div>

  </div>

</section><!-- fin filtro topbar-->

<section class="map-items-blq" id="mainBlock">
  <div class="map-items2-blq">
    <div id="map" class="split1-map gmap_canvas">
      <!--mapa ejemplo-->
      <div id='mainMap' class="mainMap">
        <!-- <div id="mapView" (click)="changeMapView()">Change</div>   -->
        <div id="mapView" *ngIf="!map_plain" (click)="changeMapView()" class="mapView mapviewtoggle sat">
          <p class="text-xs">Satélite</p>
        </div>
        <div id="mapView" *ngIf="map_plain" (click)="changeMapView()" class="mapView mapviewtoggle pla">
          <p class="text-xs">Mapa</p>
        </div>
      </div>

    </div>
    <!-- fin map-->

    <div class="split2-real-state" id="real-state" infiniteScroll [scrollWindow]="true" [infiniteScrollDistance]="2"
      [infiniteScrollThrottle]="50" (scrolled)="onScroll()">
      <div class="container mt-4">

        <div class="row">
          <div class="col-12" *ngIf="helpText==''">
            <h1 *ngIf="found>0" class="fw-bold">{{found}} Inmueble<span *ngIf="found>1">s</span> encontrado<span
                *ngIf="found>1">s</span></h1>
            <h1 *ngIf="found==0" class="fw-bold">No se encontraron resultados</h1>
          </div>
          <div class="col-12" *ngIf="helpText!=''">
            <h1 class="fw-bold">
              {{helpText}}
            </h1>

          </div>
        </div>

        <div id="resultados" *ngIf="found>0">
          <div class="row">

            <div class="col-12">

              <form [formGroup]="myFormOrder">
                <select formControlName="order" class="form-select custom-select-ord float-end"
                  aria-label="Ordenar tipo de inmueble">
                  <option selected value="">Ordenar por</option>
                  <!-- <option value="price1">Precio: de más bajo a más alto</option>
                        <option value="price2">Precio: de más alto a más bajo</option> -->
                  <option value="size1">Superficie: de mayor a menor</option>
                  <option value="size2">Superficie: de menor a mayor</option>

                </select>
              </form>
            </div>

          </div>

          <div class="row">
            <div class="col-12 real-state-blq scroll-container" *ngIf="datosListos">

              <!-- inicio card real-state-blq-inner-->
              <div class="card mb-3 real-state-blq-inner auto-h"
                *ngFor="let prop of propExtend.slice(0, startIndex + pageSize) ; let i=index">
                <div class="row g-0">
                  <div class="col-md-4 auto-h-inner">
                    <a class="" (click)="goPropertyDetail(prop.id)" title="ir al detalle del inmueble">
                      <span *ngIf="!prop?.thumbnail; else image_correct">
                        <!-- <img 
                          src="assets/img/inmuebles/ejemplo{{0 | rndImg}}.jpg" class="img-fluid rounded-start img-full-cover" alt="imagen principal inmueble"> -->

                        <span
                          *ngIf="prop.generatedComment == 'Alquilado' || prop.generatedComment == 'Vendido'; else available">

                          <img *ngIf="prop.generatedComment == 'Alquilado'" src="assets/img/local_rented.jpg"
                            class="img-fluid rounded-start img-full-cover" alt="imagen principal inmueble">
                          <img *ngIf="prop.generatedComment == 'Vendido'" src="assets/img/local_sold.jpg"
                            class="img-fluid rounded-start img-full-cover" alt="imagen principal inmueble">
                        </span>
                        <ng-template #available>
                          <img src="assets/img/inmuebles/ejemplo42.jpg" class="img-fluid rounded-start img-full-cover"
                            alt="imagen principal inmueble">
                        </ng-template>
                      </span>


                      <ng-template #image_correct>
                        <img [src]="'https://'+prop.thumbnail"  class="img-fluid rounded-start img-full-cover"
                          alt="imagen principal inmueble">

                        <span *ngIf="prop.generatedComment == ''" class="local_mark_listing">

                          <!-- Aqui iria la etiqueta -->
                          <img src="assets/img/local_available2.png" alt="Local disponible"
                            class="img_mark_listing img-full-cover">
                        </span>


                        <span *ngIf="prop.generatedComment == 'Alquilado'" class="local_mark_listing">

                          <!-- Aqui iria la etiqueta -->
                          <img src="assets/img/local_rented.png" alt="Local alquilado"
                            class="img_mark_listing img-full-cover">
                        </span>
                        <span *ngIf="prop.generatedComment == 'Vendido'" class="local_mark_listing">

                          <!-- Aqui iria la etiqueta -->
                          <img src="assets/img/local_sold.png" alt="Local vendido"
                            class="img_mark_listing img-full-cover">
                        </span>
                      </ng-template>

                    </a>


                    <div class="comment-list" *ngIf="prop.comment; else generatedCommentTxt">{{prop.comment}}</div>
                    <ng-template #generatedCommentTxt>
                      <div *ngIf="prop.generatedComment != 'Alquilado' && prop.generatedComment != 'Vendido'"
                        class="comment-list-grey">{{prop.generatedComment}}</div>
                    </ng-template>

                  </div>
                  <div class="col-md-8 px-0">
                    <div class="card-body">
                      <a class="" (click)="goPropertyDetail(prop.id)" title="ir al detalle del inmueble">
                        <h5 class="card-title fw-bold rco mb-0">{{prop.generatedName}}</h5>
                      </a>
                      <!-- {{prop.generatedComment}} -->
                      <p class="card-text"><small class="text-muted">{{prop.address}}</small>
                        . <small class="text-muted">{{prop.cityName}}</small></p>

                    </div>

                    <div class="featured">
                      <p class="m2 fw-bold mb-0">{{prop.surfaceTotal | number: '1.0-0'}}m<sup>2</sup></p>
                      <p *ngIf="prop.priceVisible" class="price fw-bold mb-0">

                        <span *ngIf="isSearch4 == '1'">
                          {{prop.askingPriceSale | number: '1.0-0'}}€
                        </span>
                        <span *ngIf="isSearch4 == '2'">
                          {{prop.askingPriceRent | number: '1.0-0'}}€/mes
                        </span>

                      </p>
                      <p *ngIf="prop.smokeStractor" class="humo fw-bold mb-0">Salida humos</p>
                    </div>
                    <div class="card-body">
                      <a (click)="mapCentreProp(prop.lat!, prop.lng!)" class="map-state" title="Ver en mapa">Ver en
                        mapa</a>
                    </div>
                  </div>
                </div>
              </div><!-- fin card real-state-blq-inner-->

            </div> <!-- fin real-state-blq-->

          </div> <!-- fin row real-state-blq-->

          <div class="row">

          </div>
        </div>

        <!-- <pagination-controls
        *ngIf="found>10"
        class="my-pagination"
        (pageChange)="onPageChange($event)"
        previousLabel=""
        nextLabel=""
        ></pagination-controls> -->

      </div> <!-- fin container-->

    </div>
    <!-- fin map-items-->

  </div>
</section>

<section class="btns-map-list">

  <div id="orange-position" class="btn-map-mbl position-absolute bottom-0 start-50 translate-middle-x">
    <a (click)="viewMap()" class="map-mbl" title="ver mapa en dispositivos móviles"><img src="assets/img/icon-map.svg"
        width="35" alt="icono mapa en dispositivos móviles"></a>

  </div>
  <!-- fin btn mostrar mapa-->

  <div id="list-position" class="btn-state-mbl position-absolute bottom-0 start-50 translate-middle-x"
    class="sinMostrar">

    <a (click)="viewMap()" class="list-mbl" title="ver inmuebles en dispositivos móviles"><img
        src="assets/img/icon-list.svg" width="25" alt="icono mapa en dispositivos móviles"></a>
  </div>
  <!-- fin btn mostrar inmuebles-->
</section>


<!-- inicio filtro offcanvas PARA VIVIENDAS-->
<div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasWithBackdrop"
  aria-labelledby="offcanvasWithBackdropLabel">
  <div class="offcanvas-header">
    <h5 class="offcanvas-title fw-bold" id="offcanvasWithBackdropLabel">Filtrar por:</h5>
    <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body">

    <form [formGroup]="filterForm">
      <div class="row">
        <div class="col-12 mb-4">
          <h5 class="mb-2">Superficie Total</h5>
          <div class="custom-slider">
            <ngx-slider [(value)]="value" formControlName="ftSupTotal" [options]="optionsSup"></ngx-slider>
          </div>
        </div>
      </div><!-- fin multi slider 2 precio-->


      <div class="row">
        <div class="col-12 mb-4">
          <h5 class="mb-4">Superficie Bajo rasante</h5>

          <div class="custom-slider">
            <ngx-slider [(value)]="value2" formControlName="ftSupBr" [options]="optionsSup"></ngx-slider>
          </div>
        </div>
      </div><!-- fin multi slider 1 superficie-->

      <!-- <div class="row">
       <div class="col-12 mb-4"> 
          <div class="form-check form-switch form-check-inline">
             <input class="form-check-input" type="checkbox" id="SalidaHumos"
             formControlName="smoke"
             >
             <label class="form-check-label" for="SalidaHumos">Salida humos</label>
          </div>
       </div>
    </div> -->


      <div class="btn-filter-sup-options">
        <a role="button" (click)="filterSupOptions()" title="Filtrar otros tipos de superficies">
          <i class="fa-solid fa-chevron-down"></i> Otros tipos de superficies <i class="fa-solid fa-chevron-down"></i>
        </a>
      </div>


      <div [ngClass]="viewFilters ? 'viewFilters' : 'noViewFilters'">
        <div class="row">
          <div class="col-12 mb-4">
            <h5 class="mb-4">Superficie construida entreplanta</h5>
            <div class="custom-slider">
              <ngx-slider [(value)]="value3" formControlName="ftSupMezz" [options]="optionsSup"></ngx-slider>
            </div>

          </div>
        </div><!-- fin multi slider 1 superficie-->

        <div class="row">
          <div class="col-12 mb-4">
            <h5 class="mb-4">Superficie construida planta baja</h5>
            <div class="custom-slider">
              <ngx-slider [(value)]="value4" formControlName="ftSupPb" [options]="optionsSup"></ngx-slider>
            </div>
          </div>
        </div><!-- fin multi slider 1 superficie-->

        <div class="row">
          <div class="col-12 mb-4">
            <h5 class="mb-4">Superficie construida planta 1</h5>
            <div class="custom-slider">
              <ngx-slider [(value)]="value5" formControlName="ftSupBase1" [options]="optionsSup"></ngx-slider>
            </div>
          </div>
        </div><!-- fin multi slider 1 superficie-->

        <div class="row">
          <div class="col-12 mb-4">
            <h5 class="mb-4">Superficie construida planta 2</h5>
            <div class="custom-slider">
              <ngx-slider [(value)]="value6" formControlName="ftSupBase2" [options]="optionsSup"></ngx-slider>
            </div>
          </div>
        </div><!-- fin multi slider 1 superficie-->

      </div>



      <div class="row">
        <div class="col-12 btns-filter py-2">
          <a data-bs-toggle="offcanvas" href="#offcanvasWithBackdrop" id="btn-filter-sup-options"
            class="btn btn-search mb-4" role="button" (click)="propFind()" title="Filtrar otros tipos de superficies">
            Aplicar filtros
          </a>
          <a class="mt-2 btns-filter-del">Reiniciar todos los filtros</a>
        </div>
      </div><!-- fin multi slider 2 precio-->
    </form>
  </div>



</div>



<app-footer-main [isInmuebles]="true"></app-footer-main>